import(/* webpackMode: "eager" */ "/app/src/app/[locale]/web-seo/page.tsx");
